export const shop = {
  overview: {
    title: "Installationen",
    noPrice: "Kein Preis vorhanden",
    categories: {
      "technic-and-logistic": "Technik und Logistik",
      "stand-construction": "Standbau-Service",
      "electrical-supply": "Elektroversorgung",
      telephony: "Telefonie",
      "systemstand-typ-slim-color": "Systemstand Typ Slim Color",
      "systemstand-typ-a-color": "Systemstand Typ A Color",
      "systemstand-typ-b-color": "Systemstand Typ B Color",
      "systemstand-typ-slim": "Systemstand Typ Slim",
    },
    menu: {
      default: "Alle Produkte",
    },
    header: {
      info: {
        title: "Weitere Informationen",
      },
      search: {
        title: "Alle Produkte",
        input: "Suche nach ...",
        clear: "Suche löschen",
      },
      category: {
        label: "Kategorie",
        title: "Kategorie wählen",
        back: "Alle Kategorien",
        all: "Alle in",
        close: "Schließen",
      },
      sorting: {
        input: "Sortieren nach",
        items: {
          default: "Standard",
          favorite: "Relevanz",
          alphabeticUp: "Alphabetisch (A-Z)",
          alphabeticDown: "Alphabetisch (Z-A)",
          priceUp: "Preis aufsteigend",
          priceDown: "Preis absteigend",
        },
      },
    },
    salesorderSelectionDialog: {
      title: "Standbuchung auswählen",
      info: "Das Bestellen auf eigene Rechnung ist nur möglich, wenn Ihr Konto autorisiert wurde. Wenn Sie sich noch nicht autorisiert haben, klicken Sie unten auf die Schaltfläche - Jetzt autorisieren -. Andernfalls sind nur Bestellungen auf die Ansprechpartner Ihrer selbst erstellten Standanmeldungen möglich, oder auf fremde Rechnung, wenn Sie von einer anderen Person als Stellvertreter benannt wurden.",
      desc: "Bitte wählen Sie eine Standbuchung aus, um den Bestellprozess zu starten. Sie können Ihre aktive Standbuchung jederzeit über die Auswahl im Kopfbereich ändern.",
      input: "Standbuchung",
      noData: "Sie haben derzeitig keine aktiven Buchungen.",
      standhall: " | Halle ",
      standnumber: " | Stand ",
      buttons: {
        jumpOver: "Vorerst überspringen",
        disable: "Nicht mehr anzeigen",
        authorize: "Jetzt autorisieren",
        request: "Standbuchung anfragen",
        permission: "Berechtigung erteilen",
      },
    },
    salesorderRequestDialog: {
      title: "Standbuchung anfragen",
      desc: "Wenn Sie Zugriff auf die Standbuchung eines Hauptausstellers benötigen, geben Sie hier bitte die erforderlichen Informationen an. Nach erfolgreicher Autorisierung können Sie für die Standbuchung auf eigene Rechnung bestellen. Kontaktieren Sie den Hauptaussteller direkt, wenn Sie in seinem Namen bestellen möchten, anstatt auf eigene Rechnung.",
      buttons: {
        send: "Senden",
        cancel: "Abbrechen",
      },
      checkbox: "Ich möchte eine Anfrage mit Standbuchungsdaten absenden.",
      form: {
        inputs: {
          standhall: {
            label: "Halle",
          },
          standnumber: {
            label: "Standnummer",
          },
          standsize: {
            label: "Quadratmeter",
          },
        },
      },
    },
    contactDialog: {
      title: "Kontaktinformationen",
      description: "Beschreibung",
      orderDeadline: "Bestellfrist",
      orderDeadlineInfo: "Informationen zur Bestellfrist",
      contactPerson: "Ansprechpartner",
    },
    products: {
      prefix: "ab",
      route: "produkt-details",
      noResults: {
        title: "Keine Treffer",
        search: "Für Ihre Suche wurden keine Artikel gefunden.",
        category: "In dieser Kategorie gibt es keine Artikel.",
        reset: "Filter zurücksetzen",
      },
    },
    sidebar: {
      info: {
        title: "Achtung",
      },
      contact: {
        title: "Ansprechpartner",
      },
      links: {
        title: "Dokumente & Links",
      },
    },
  },
  detail: {
    header: {
      navigation: {
        backToOverview: "Zurück zur Übersicht",
        backToProduct: "Zurück zum Hauptprodukt",
      },
      content: {
        button: {
          title: "Zum Warenkorb hinzufügen",
          titleAdd: "+1 zum Warenkorb hinzufügen",
          titleNoAdd: "Merkmale ansehen",
          helper:
            "Um ein Produkt zum Warenkorb hinzufügen zu können, bitten wir Sie, eine Standbuchung auszuwählen.",
          helper1:
            "Um ein Produkt zum Warenkorb hinzufügen zu können, melden Sie sich bitte an.",
          maxAmountReached:
            "Die maximale Bestellmenge für dieses Produkt wurde erreicht. ",
        },
        mandatoryProductLabel: "Die folgenden Pflichtprodukte sind enthalten:",
      },
    },
    productFeatureDialog: {
      title: "Wir benötigen von Ihnen ein paar zusätzliche Informationen",
      titleUpdate: "Produkt anpassen",
      add: "Zum Warenkorb hinzufügen",
      update: "Warenkorb aktualisieren",
      cancel: "Abbrechen",
    },
    snackbar: {
      notFound: "Das Produkt kann nicht gefunden werden.",
    },
    tab: {
      optionalProductLabel: "Zusatzausstattungen",
      info: "Sobald Sie Ihr Hauptprodukt zum Warenkorb hinzugefügt haben, haben Sie die Möglichkeit, optionale Produkte auszuwählen. Klicken Sie auf die gewünschten Produkte und fügen Sie sie zum Warenkorb hinzu.",
    },
  },
  cart: {
    productCard: {
      remove: "Löschen",
      expand: "Anpassen",
      checkboxValueTrue: "Ja",
      checkboxValueFalse: "Nein",
      mandatoryProductsLabel: "Inkl. Pflichtprodukte:",
      fileValueText: "Datei(en) hochgeladen",
    },
    dialog: {
      title: "Mein Warenkorb",
      noProducts:
        "Sie haben noch keine Produkt zu Ihrer ausgewählten Buchung hinzugefügt.",
      buttons: {
        checkout: "Zur Kasse gehen",
        back: "Weiter einkaufen",
      },
      total: "Gesamtsumme",
    },
    snackbar: {
      add: "Ihr Produkt wurde erfolgreich zum Warenkorb hinzugefügt.",
      changed:
        "Die Anzahl Ihres ausgewählten Produkts wurde erfolgreich erhöht.",
      refreshed:
        "Ihr Warenkorb wurde aktualisiert. Bitte prüfen Sie Ihre Bestellung.",
    },
    overview: {
      backToShop: "Zurück zum Store",
      noData: "Ihr Warenkorb ist leer.",
    },
    checkout: {
      tosCard: {
        generalTermsAndConditions: "Allgemeine Geschäftsbedingungen",
        privacyPolicies: "Datenschutzhinweise",
        categoryGeneralTermsAndConditions:
          "Produktspezifische Geschäftsbedingungen",
        categoryPrivacyPolicies: "Produktspezifische Datenschutzhinweise",
        categoryLabel: "Für Produkte aus ",
        acceptAll: "Alle akzeptieren",
      },
      billingCard: {
        debitorDesc: {
          onOwnAccount:
            "Sie sind dazu berechtigt, Nebenleistungen für den Stand {orderNumber} zu bestellen.",
          onExternalAccount:
            "Sie sind dazu berechtigt Nebenleistungen im Namen von {externalCompany} zu bestellen.",
        },
        debitorLabel: "Auf eigene Rechnung bestellen",
        invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        emailLabel: "eInvoice",
      },

      ccInformation: {
        title: "Kreditkarten  Details",
        name: {
          label: "Name",
        },
        number: {
          label: "Nummer",
        },
        expirationDate: {
          label: "Gültig bis",
        },
        cvv: {
          label: "CVV",
        },
        validation: {
          number: "Bitte geben Sie eine gültige Kreditkartennummer ein.",
          expirationDate: "Bitte geben Sie ein gültiges Ablaufdatum ein.",
          cvv: "Bitte geben Sie einen gültigen CVV ein.",
        },
      },
      summary: {
        booking: "Nebenleistungen zur Standbuchung",
        total: "Gesamtsumme Netto",
        partialCheckout: "Teilbestellung absenden",
        checkout: "Bestellung absenden",
        conditions: {
          invoiceMail: "Ihre eInvoice wird gesendet an ",
          noInvoiceMail: "Es wurde keine eInvoice-Mail angegeben.",
          billing: "Die Bestellung erfolgt auf die Rechnung von {name}",
          noBilling: {
            own: "Mit Ihrem User ist noch keine Firma verbunden. Bitte lassen Sie sich unter Mein Account > Mein Support > Bestellautorisierung autorisieren. Sie können Ihre Bestellung trotzdem bereits abschicken.",
            foreign:
              "Es wurde kein Debitor / Firma für den Auftraggeber gefunden.",
          },
          ccInformation: "Kreditkarteninformationen wurden angegeben.",
          noCCInformation:
            "Es wurden keine Kreditkarteninformationen angegeben.",
          termsOfServices: {
            met: "Sie haben die Allgemeinen Geschäftsbedingungen und Datenschutzerklärungen akzeptiert",
            invoiceRebookings:
              "Nachträgliche Rechnungsumschreibungen werden mit 100,00 EUR zzgl. USt. berechnet.",
            unmet:
              "Sie haben die Allgemeinen Geschäftsbedingungen und Datenschutzerklärungen noch nicht vollständig akzeptiert.",
          },
        },
        redirectDialog: {
          title: "Bestellung abgesendet",
          content:
            "Ihre Bestellung wurde erfolgreich übermittelt und wird nun bearbeitet. In Kürze erhalten Sie eine Bestätigungsmail. Je nach Anzahl der bestellten Artikel kann der Versand der E-Mail bis zu 1 Stunde dauern.",
          button: "Zur Standübersicht",
        },
      },
    },
  },
  standBookingRequestsOverview: {
    table: {
      name: {
        label: "Auftragsnummer",
      },
      standhall: {
        label: "Halle",
      },
      standnumber: {
        label: "Standnummer",
      },
      standsize: {
        label: "Quadratmeter",
      },
      state: {
        label: "Status",
        items: {
          Approved: "Genehmigt",
          Pending: "In Bearbeitung",
          Declined: "Abgelehnt",
        },
      },
    },
    noData: "Derzeit sind keine Standbuchungsanfragen vorhanden.",
  },
  incidents: {
    noData: "Derzeit liegen keine Serviceanfragen vor.",
    table: {
      order: {
        label: "Referenznummer",
      },
      name: {
        label: "Anfrage",
      },
      type: {
        label: "Typ",
        items: {
          Claim: "Reklamation",
          Cancellation: "Stornierung",
          AuthorizationRequest: "Authorisierung",
        },
      },
      status: {
        label: "Status",
        items: {
          Closed: "Genehmigt",
          Active: "In Bearbeitung",
          Cancelled: "Abgelehnt",
        },
      },
      description: {
        label: "Beschreibung",
      },
    },
  },
  orders: {
    print: {
      title: "Bestellübersicht",
    },
    dropdown: {
      label: "Bearbeiten",
      print: "Drucken",
    },
    select: {
      exhibitions: {
        label: "Veranstaltung",
        items: {
          all: "Alle",
        },
      },
      bookings: {
        label: "Auftrag",
        items: {
          all: "Alle",
        },
        standhall: " | Halle ",
        standnumber: " | Stand ",
      },
    },
    tabs: {
      orderOnOwnAccount: "Auf eigene Rechnung",
      orderOnForeignAccount: "Auf Rechnung des Hauptkontakts",
    },
    table: {
      booking: {
        label: "Standbuchung",
      },
      exhibition: {
        label: "Veranstaltung",
      },
      standhall: {
        label: "Halle",
      },
      standnumber: {
        label: "Stand",
      },
      name: {
        label: "Bestellnummer",
      },
      date: {
        label: "Bestelldatum",
      },
      status: {
        label: "Bestellstatus",
        items: {
          InProgress: "In Bearbeitung",
          Invoiced: "Freigegeben",
          Closed: "Abgeschlossen",
        },
      },
      total: {
        label: "Gesamtsumme Netto",
        noAmount: "Bestelleingang wird geprüft",
      },
    },
    details: {
      snackbar: {
        noProductFound: "Das Produkt kann nicht gefunden werden.",
      },
      noData: "Keine Bestellung gefunden.",
      print: {
        title: "Bestelldetails",
      },
      dropdown: {
        label: "Bearbeiten",
        print: "Drucken",
        cancel: "Stornieren",
        complain: "Reklamieren",
      },
      status: {
        cancellation: {
          cancelled: "Storniert",
          requested: "Stornierung angefragt",
          denied: "Stornierung abgelehnt",
        },
        complaint: {
          cancelled: "Reklamiert",
          requested: "Reklamation angefragt",
          denied: "Reklamation abgelehnt",
        },
        active: "Aktiv",
        cancelled: "Abgesagt",
        invoiced: "Fakturiert",
        approved: "Freigegeben",
      },
      summary: {
        exhibition: "Veranstaltung",
        booking: "Standbuchung",
        orderNumber: "Bestellnummer",
        orderDate: "Bestelldatum",
        standhall: "Halle",
        standnumber: "Stand",
        status: {
          label: "Bestellstatus",
          items: {
            InProgress: "In Bearbeitung",
            Invoiced: "Freigegeben",
            Closed: "Abgeschlossen",
          },
        },
        total: {
          label: "Gesamtsumme Netto",
          noAmount: "Bestelleingang wird geprüft",
        },
      },
      address: {
        billingAddress: "Rechnungsadresse",
        shippingAddress: "Debitorenadresse",
        email: "Kontakt",
        sender: "Absender",
      },
      complainDialog: {
        title: "Bestellung reklamieren",
        description:
          "Sie können eine oder mehrere Positionen reklamieren, indem Sie die für die entsprechende Position aufgeführten Ansprechpartner kontaktieren.",
        noContact: "Keine Ansprechpartner vorhanden",
        buttons: {
          close: "Schließen",
        },
      },
      cancelOrderDialog: {
        title: "Bestellung stornieren",
        description:
          "Sie können einzelne Positionen ihrer Bestellung stornieren, indem Sie nur diese auswählen. Soll die gesamte Bestellung storniert werden, wählen Sie alles aus. Bitte wählen Sie mindestens eine Position aus und geben vor dem Absenden einen Grund für die Stornierung an.",
        reason: {
          label: "Grund für die Stornierung",
        },
        items: {
          all: "Gesamte Bestellung auswählen",
        },
        buttons: {
          cancelOrder: "Stornieren",
          close: "Schließen",
        },
      },
    },
    noData: "Keine Bestellungen vorhanden.",
  },
}
